module.exports = {"id":"223751","name":"Gideon Jung","rating":"72","photo":"./data/images/photos/2/223751.png","club":{"name":"Hambourg SV","logo":"./data/images/clubs/HambourgSV.png"},"positions":["MDC","DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GideonJung0.json
// module id = 1593
// module chunks = 0